module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2017/june-fbdafe5d395e2c29533f0b721b61fbc4.png";